<script setup lang="ts">
import LegalDocumentsDialog from '@/components/core/legal-documents/LegalDocumentsDialog.vue'
</script>

<template>
  <div class="h-screen flex align-center justify-center">
    <LegalDocumentsDialog />
  </div>
</template>
